(function(window, document, $) {
  'use strict';

  var STORAGE_KEY = 'nideco.cart_runtime';
  var PREVIEW_VALUE = 'v2';
  var PAGE_PREVIEW_VALUE = 'v2-page';
  var LEGACY_VALUE = 'legacy';
  var MAX_UPSELLS = 5;
  var STAR_RATING_SVG = '<svg viewBox="0 0 49.96 8.86" xmlns="http://www.w3.org/2000/svg" width="80" height="15"><g fill="#ffe200"><path d="m4.66 0 1.44 2.92 3.22.47-2.33 2.27.55 3.2-2.88-1.51-2.88 1.51.55-3.2-2.33-2.27 3.22-.47z"/><path d="m14.82 0 1.44 2.92 3.22.47-2.33 2.27.55 3.2-2.88-1.51-2.88 1.51.55-3.2-2.33-2.27 3.22-.47z"/><path d="m24.98 0 1.44 2.92 3.22.47-2.33 2.27.55 3.2-2.88-1.51-2.88 1.51.55-3.2-2.33-2.27 3.22-.47z"/><path d="m35.14 0 1.44 2.92 3.22.47-2.33 2.27.55 3.2-2.88-1.51-2.88 1.51.55-3.2-2.33-2.27 3.22-.47z"/><path d="m45.3 0 1.44 2.92 3.22.47-2.33 2.27.55 3.2-2.88-1.51-2.88 1.51.55-3.2-2.33-2.27 3.22-.47z"/></g></svg>';
  var DEFAULT_THRESHOLDS = [
    {
      key: 'shipping',
      label: 'Livraison offerte',
      at: 5000,
      value: '',
      rewardName: 'livraison offerte',
      upsellCopy: 'livraison offerte'
    },
    {
      key: 'gift-one',
      label: 'Crème mains offerte',
      at: 8000,
      value: '10,90€',
      rewardName: 'la crème soin mains',
      upsellCopy: 'crème mains offerte'
    },
    {
      key: 'gift-two',
      label: 'Reboot me Baby',
      at: 13000,
      value: '29,00€',
      rewardName: 'Reboot me Baby',
      upsellCopy: 'Reboot me Baby offert'
    }
  ];
  var DEFAULT_HIGHLIGHTED_HANDLES = [
    'kit',
    'fesse-time',
    'masque-gommant-doux-illumine-mixed-feelings',
    'clean-that-face',
    'all-i-need-hydratant-anti-pollution',
    'soin-eclat-vitamine-bonne-mine-naturel',
    'soin-de-nuit-regenerant'
  ];
  var DEFAULT_KIT_UPSELL_MAP = {
    'fesse-time': 'trio-bodyguard',
    'masque-gommant-doux-illumine-mixed-feelings': 'routine-peau-visage-eclat',
    'clean-that-face': 'routine-peau-visage-eclat',
    'soin-eclat-vitamine-bonne-mine-naturel': 'routine-peau-visage-eclat',
    'oh-my-periods': 'kit-bouleversements-hormonaux',
    'soin-apaisant-raffermissant-seins-tits-party': 'kit-bouleversements-hormonaux',
    'gel-intime-apaisant-lubrifiant-protecteur-south-beauty': 'kit-bouleversements-hormonaux',
    'not-my-problem-serum-douleurs-menstruelles': 'kit-bouleversements-hormonaux',
    'soin-reparateur-hydratant-im-not-a-mermaid': 'trio-routine-corps',
    'masque-regenerant-reboot-me-baby': 'kit-cozy-night-essentials',
    'soin-de-nuit-regenerant': 'kit-cozy-night-essentials',
    'huile-demaquillante': 'kit-cozy-night-essentials',
    'creme-soulager-jambes-lourdes': 'kit-100-fresh',
    'pate-anti-points-noirs-dot-is-not-an-option': 'routine-peau-saine',
    'baume-anti-stress-im-a-survivor': 'detox-anti-stress-visage-corps',
    'gelee-corps-muscles-upper-chill': 'trio-bodyguard'
  };
  var DEFAULT_UPSELL_CONFLICTS = {
    'fesse-time': ['trio-purete', 'trio-bodyguard', 'trio-best-of', 'offre-speciale-limitee-fesse-time', 'trio-maillot', 'duo-vitamine-fesse-visage-eclat'],
    'masque-gommant-doux-illumine-mixed-feelings': ['routine-peau-visage-eclat', 'trio-best-of'],
    'clean-that-face': ['routine-peau-visage-eclat', 'pack-special-oh-my-periods-clean-that-face', 'offre-speciale-limitee-fesse-time', 'all-i-need-clean-that-face'],
    'all-i-need-hydratant-anti-pollution': ['all-i-need-clean-that-face'],
    'soin-eclat-vitamine-bonne-mine-naturel': ['routine-peau-visage-eclat', 'duo-vitamine-fesse-visage-eclat']
  };
  var DEFAULT_GIFTS = {
    'offre-speciale-two-cart': {
      title: 'Crème soin mains',
      subtitle: "I'm not a Mermaid Mains",
      comparePrice: '10,90€',
      previewHandle: 'soin-reparateur-hydratant-im-not-a-mermaid'
    },
    'offre-speciale-cart': {
      title: 'Reboot me Baby',
      subtitle: 'Notre masque régénérant',
      comparePrice: '29,00€',
      previewHandle: 'masque-regenerant-reboot-me-baby'
    },
    'default-cart-cadeau': {
      title: 'Crème soin mains',
      subtitle: "I'm not a Mermaid Mains",
      comparePrice: '10,90€',
      previewHandle: 'soin-reparateur-hydratant-im-not-a-mermaid'
    },
    'cadeau-special-mini-vibro-dive': {
      title: 'Mini Vibro Dive',
      subtitle: 'Notre mini vibromasseur nomade',
      comparePrice: '',
      previewHandle: 'cadeau-special-mini-vibro-dive'
    },
    'carte-cadeau-nideco-15': {
      title: 'Carte cadeau Nideco 15€',
      subtitle: 'À offrir ou à garder',
      comparePrice: '15,00€',
      previewHandle: 'carte-cadeau-nideco-15'
    }
  };
  var DEFAULT_PREVIEW = {
    hoverDelay: 260,
    closeDelay: 140,
    descriptionLength: 280,
    mobileButtonLabel: 'Aperçu rapide',
    quickAddLabel: 'Ajouter'
  };
  var UPSELL_BENEFIT_MAP = {
    'fesse-time': 'Le soin anti-boutons corps le + demandé',
    'masque-gommant-doux-illumine-mixed-feelings': 'Un coup d\'éclat en 5 minutes chrono',
    'clean-that-face': 'La base pour une peau nette au quotidien',
    'all-i-need-hydratant-anti-pollution': 'Protège et hydrate chaque jour',
    'soin-eclat-vitamine-bonne-mine-naturel': 'Effet bonne mine immédiat',
    'soin-de-nuit-regenerant': 'Régénère ta peau pendant la nuit',
    'oh-my-periods': 'Rééquilibre ta peau en période pré-menstruelle',
    'masque-regenerant-reboot-me-baby': 'Masque éclat défatiguant, 5 min chrono',
    'soin-reparateur-hydratant-im-not-a-mermaid': 'Répare et hydrate les zones sèches',
    'huile-demaquillante': 'Démaquillage doux et nourrissant',
    'pate-anti-points-noirs-dot-is-not-an-option': 'Cible les points noirs en profondeur',
    'baume-anti-stress-im-a-survivor': 'Apaise le stress visible sur ta peau',
    'gelee-corps-muscles-upper-chill': 'Soulage les tensions musculaires',
    'creme-soulager-jambes-lourdes': 'Jambes légères et toniques'
  };
  var DEFAULT_GIFT_BAG_VARIANT_ID = '47385210224970';
  var CART_CONFIG = window.NidecoCartConfig || {};
  var THRESHOLD_STEPS = normalizeThresholdConfig(CART_CONFIG.thresholds);
  var HIGHLIGHTED_HANDLES = normalizeHandles(CART_CONFIG.highlightedHandles, DEFAULT_HIGHLIGHTED_HANDLES);
  var KIT_UPSELL_MAP = mergeRecords(DEFAULT_KIT_UPSELL_MAP, CART_CONFIG.kitUpsellMap);
  var UPSELL_CONFLICTS = mergeArrayRecords(DEFAULT_UPSELL_CONFLICTS, CART_CONFIG.upsellConflicts);
  var GIFT_METADATA = mergeGiftMetadata(DEFAULT_GIFTS, CART_CONFIG.gifts);
  var PREVIEW_CONFIG = mergeRecords(DEFAULT_PREVIEW, CART_CONFIG.preview);
  var FREE_GIFT_HANDLES = buildBooleanMap(Object.keys(GIFT_METADATA));
  var GIFT_BAG_VARIANT_ID = String(CART_CONFIG.giftBagVariantId || DEFAULT_GIFT_BAG_VARIANT_ID);
  var pagePreviewMode = '';
  var productCache = {};
  var productPromises = {};
  var giftBagPending = false;
  var giftItemSyncPending = {};
  var pendingAddState = {
    phase: '',
    buttons: [],
    startedAt: 0,
    startItemCount: 0,
    startTotalPrice: 0,
    resetTimer: 0
  };
  var previewState = {
    requestToken: '',
    activeHandle: '',
    activeProduct: null,
    isOpen: false,
    lastTrigger: '',
    hoverOpenTimer: 0,
    hoverCloseTimer: 0,
    isInsideModal: false,
    quickAddVariantId: '',
    quickAddLabel: '',
    sourceHandle: ''
  };

  function normalizeHandles(value, fallback) {
    if (Object.prototype.toString.call(value) === '[object Array]' && value.length) {
      return value.slice(0);
    }

    return fallback.slice(0);
  }

  function mergeRecords(defaults, overrides) {
    var result = {};
    var key;

    for (key in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, key)) {
        result[key] = defaults[key];
      }
    }

    if (!overrides) {
      return result;
    }

    for (key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== undefined) {
        result[key] = overrides[key];
      }
    }

    return result;
  }

  function mergeArrayRecords(defaults, overrides) {
    var result = {};
    var key;

    for (key in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, key)) {
        result[key] = defaults[key].slice(0);
      }
    }

    if (!overrides) {
      return result;
    }

    for (key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key) && Object.prototype.toString.call(overrides[key]) === '[object Array]') {
        result[key] = overrides[key].slice(0);
      }
    }

    return result;
  }

  function mergeGiftMetadata(defaults, overrides) {
    var result = {};
    var key;

    for (key in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, key)) {
        result[key] = mergeRecords(defaults[key], defaults[key]);
      }
    }

    if (!overrides) {
      return result;
    }

    for (key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key)) {
        result[key] = mergeRecords(defaults[key] || {}, overrides[key]);
      }
    }

    return result;
  }

  function buildBooleanMap(keys) {
    var result = {};
    var i;

    for (i = 0; i < keys.length; i += 1) {
      result[keys[i]] = true;
    }

    return result;
  }

  function normalizeThresholdConfig(value) {
    var source = Object.prototype.toString.call(value) === '[object Array]' && value.length ? value : DEFAULT_THRESHOLDS;

    return source.map(function(step, index) {
      var fallback = DEFAULT_THRESHOLDS[index] || DEFAULT_THRESHOLDS[DEFAULT_THRESHOLDS.length - 1];

      return {
        key: step.key || fallback.key,
        label: step.label || fallback.label,
        at: Number(step.at || fallback.at || 0),
        value: step.value || fallback.value || '',
        rewardName: step.rewardName || fallback.rewardName || step.label || fallback.label,
        upsellCopy: step.upsellCopy || fallback.upsellCopy || step.label || fallback.label
      };
    });
  }

  function getThresholdSteps() {
    return THRESHOLD_STEPS.slice(0);
  }

  function getThresholdStepByKey(key) {
    var steps = getThresholdSteps();
    var i;

    for (i = 0; i < steps.length; i += 1) {
      if (steps[i].key === key) {
        return steps[i];
      }
    }

    return null;
  }

  function getLastThresholdStep() {
    var steps = getThresholdSteps();

    if (!steps.length) {
      return null;
    }

    return steps[steps.length - 1];
  }

  function getShippingThresholdStep() {
    return getThresholdStepByKey('shipping') || getThresholdSteps()[0] || DEFAULT_THRESHOLDS[0];
  }

  function getQueryParam(key) {
    var query = window.location.search.substring(1).split('&');
    var i;

    for (i = 0; i < query.length; i += 1) {
      var parts = query[i].split('=');

      if (decodeURIComponent(parts[0] || '') === key) {
        return decodeURIComponent(parts[1] || '');
      }
    }

    return '';
  }

  function getStoredPreviewMode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return '';
    }
  }

  function setStoredPreviewMode(value) {
    try {
      if (!value || value === 'off' || value === 'reset') {
        window.localStorage.removeItem(STORAGE_KEY);
        return;
      }

      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      return;
    }
  }

  function isActive() {
    return pagePreviewMode === PREVIEW_VALUE || getStoredPreviewMode() !== LEGACY_VALUE;
  }

  function syncRootMode() {
    document.documentElement.setAttribute('data-cart-runtime', isActive() ? PREVIEW_VALUE : LEGACY_VALUE);
  }

  function setPagePreviewMode(value) {
    pagePreviewMode = value === PREVIEW_VALUE ? PREVIEW_VALUE : '';
    syncRootMode();
  }

  function setPreviewMode(value) {
    if (value === PAGE_PREVIEW_VALUE) {
      setStoredPreviewMode('off');
      setPagePreviewMode(PREVIEW_VALUE);
      return;
    }

    setPagePreviewMode('');
    setStoredPreviewMode(value);
    syncRootMode();
  }

  function syncPreviewModeFromQuery() {
    var mode = getQueryParam('cart_runtime');

    if (!mode) {
      return;
    }

    setPreviewMode(mode);
  }

  function matchesSelector(node, selector) {
    var matcher;

    if (!node || node.nodeType !== 1) {
      return false;
    }

    matcher = node.matches || node.msMatchesSelector || node.webkitMatchesSelector || node.mozMatchesSelector;

    if (!matcher) {
      return false;
    }

    return matcher.call(node, selector);
  }

  function findClosestBySelector(element, selector) {
    var node = element;

    while (node && node !== document) {
      if (matchesSelector(node, selector)) {
        return node;
      }

      node = node.parentNode;
    }

    return null;
  }

  function findClosestWithAttribute(element, attributeName) {
    var node = element;

    while (node && node !== document) {
      if (node.nodeType === 1 && node.hasAttribute(attributeName)) {
        return node;
      }

      node = node.parentNode;
    }

    return null;
  }

  function getCart(cart) {
    if (cart) {
      return cart;
    }

    if (window.CartJS && window.CartJS.cart) {
      return window.CartJS.cart;
    }

    return {
      item_count: 0,
      total_price: 0,
      total_weight: 0,
      items: []
    };
  }

  function getCartHandles(cart) {
    return (cart.items || []).map(function(item) {
      return item.handle;
    });
  }

  function hasPromiseSupport() {
    return !!(window.Promise && typeof window.Promise.all === 'function');
  }

  function hasHandle(handles, handle) {
    return handles.indexOf(handle) !== -1;
  }

  function setProgressBar(id, totalPrice, threshold) {
    var width = 0;
    var progressBars;

    if (!id || !threshold) {
      return;
    }

    progressBars = document.querySelectorAll('[id="' + id + '"]');

    if (!progressBars.length) {
      return;
    }

    width = Math.max(0, Math.min(100, (totalPrice / threshold) * 100));

    Array.prototype.forEach.call(progressBars, function(progressBar) {
      progressBar.style.width = width + '%';
      progressBar.setAttribute('aria-valuenow', totalPrice);
    });
  }

  function updateCartCount(cart) {
    if (!$) {
      return;
    }

    $('.cart-count').html(cart.item_count);
  }

  function clearPendingAddResetTimer() {
    if (pendingAddState.resetTimer) {
      window.clearTimeout(pendingAddState.resetTimer);
      pendingAddState.resetTimer = 0;
    }
  }

  function getPendingButtonContentNode(button) {
    if (!button || button.nodeType !== 1) {
      return null;
    }

    return button.querySelector('[id="AddToCartText2"], [id="AddToCartText"], [data-cart-button-label]') || button;
  }

  function normalizePendingAddButtons(buttons) {
    var uniqueButtons = [];
    var entries = [];

    Array.prototype.forEach.call(buttons || [], function(button) {
      var contentNode;

      if (!button || uniqueButtons.indexOf(button) !== -1) {
        return;
      }

      uniqueButtons.push(button);
      contentNode = getPendingButtonContentNode(button);

      entries.push({
        button: button,
        contentNode: contentNode,
        originalHtml: contentNode ? contentNode.innerHTML : '',
        supportsDisabled: typeof button.disabled !== 'undefined',
        wasDisabled: typeof button.disabled !== 'undefined' ? !!button.disabled : false,
        wasAriaDisabled: button.getAttribute('aria-disabled') === 'true'
      });
    });

    return entries;
  }

  function resetPendingAddState() {
    clearPendingAddResetTimer();
    pendingAddState.phase = '';
    pendingAddState.buttons = [];
    pendingAddState.startedAt = 0;
    pendingAddState.startItemCount = 0;
    pendingAddState.startTotalPrice = 0;
  }

  function setPendingButtonBusyState(entry, isBusy) {
    var button = entry && entry.button;

    if (!button) {
      return;
    }

    button.classList.toggle('is-cart-loading', isBusy);
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');

    if (entry.supportsDisabled) {
      button.disabled = isBusy ? true : entry.wasDisabled;
    }

    if (isBusy) {
      button.setAttribute('aria-disabled', 'true');
    } else if (entry.wasAriaDisabled) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function restorePendingAddFeedback() {
    pendingAddState.buttons.forEach(function(entry) {
      if (entry.contentNode) {
        entry.contentNode.innerHTML = entry.originalHtml;
      }

      setPendingButtonBusyState(entry, false);
    });

    setDrawerLoadingState(false);
    resetPendingAddState();
  }

  function rememberPendingAdd(buttons) {
    if (!isActive()) {
      return;
    }

    if (pendingAddState.phase) {
      restorePendingAddFeedback();
    }

    pendingAddState.phase = 'armed';
    pendingAddState.buttons = normalizePendingAddButtons(buttons);
  }

  function buildButtonLoadingMarkup(label) {
    return '' +
      '<span class="nideco-cart-button-state nideco-cart-button-state--loading">' +
        '<span class="nideco-cart-button-spinner" aria-hidden="true">' +
          '<span class="nideco-cart-button-heart">♡</span>' +
        '</span>' +
        '<span class="nideco-cart-button-label">' + escapeHtml(label || 'Ajout en cours...') + '</span>' +
      '</span>';
  }

  function buildButtonSuccessMarkup(label) {
    return '' +
      '<span class="nideco-cart-button-state nideco-cart-button-state--success">' +
        '<span class="nideco-cart-button-check" aria-hidden="true">✓</span>' +
        '<span class="nideco-cart-button-label">' + escapeHtml(label || 'Ajouté !') + '</span>' +
      '</span>';
  }

  function applyPendingAddFeedback() {
    pendingAddState.buttons.forEach(function(entry) {
      if (entry.contentNode) {
        entry.contentNode.innerHTML = buildButtonLoadingMarkup('Ajout en cours...');
      }

      setPendingButtonBusyState(entry, true);
    });
  }

  function didPendingAddChangeCart(cart) {
    if (pendingAddState.phase !== 'pending') {
      return false;
    }

    if ((cart.item_count || 0) !== pendingAddState.startItemCount) {
      return true;
    }

    if ((cart.total_price || 0) !== pendingAddState.startTotalPrice) {
      return true;
    }

    return false;
  }

  function schedulePendingAddReset() {
    clearPendingAddResetTimer();
    pendingAddState.resetTimer = window.setTimeout(function() {
      restorePendingAddFeedback();
    }, 1800);
  }

  function updateAddToCartFeedback(success) {
    if (pendingAddState.phase !== 'pending') {
      return;
    }

    setDrawerLoadingState(false);

    if (!success) {
      restorePendingAddFeedback();
      return;
    }

    pendingAddState.buttons.forEach(function(entry) {
      if (entry.contentNode) {
        entry.contentNode.innerHTML = buildButtonSuccessMarkup('Ajouté !');
      }

      setPendingButtonBusyState(entry, false);
    });

    pendingAddState.phase = 'cooldown';
    schedulePendingAddReset();
  }

  function ensureDrawerLoadingOverlay() {
    var drawer = document.getElementById('LiveCart');
    var overlay;

    if (!drawer) {
      return null;
    }

    overlay = drawer.querySelector('.live-cart-loading-overlay');

    if (overlay) {
      return overlay;
    }

    overlay = document.createElement('div');
    overlay.className = 'live-cart-loading-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '' +
      '<div class="live-cart-loading-card" role="status" aria-live="polite">' +
        '<div class="live-cart-loading-badge">Panier en cours</div>' +
        '<div class="live-cart-loading-spinner" aria-hidden="true">' +
          '<span class="live-cart-loading-heart">♡</span>' +
          '<span class="live-cart-loading-dot live-cart-loading-dot--one"></span>' +
          '<span class="live-cart-loading-dot live-cart-loading-dot--two"></span>' +
        '</div>' +
        '<div class="live-cart-loading-title">On glisse ton soin dans le panier...</div>' +
        '<div class="live-cart-loading-copy">Petite seconde, on vérifie aussi les cadeaux éventuels.</div>' +
      '</div>';

    drawer.appendChild(overlay);
    return overlay;
  }

  function setDrawerLoadingState(isLoading) {
    var drawer = document.getElementById('LiveCart');
    var overlay = ensureDrawerLoadingOverlay();

    if (!drawer || !overlay) {
      return;
    }

    drawer.classList.toggle('is-cart-loading', !!isLoading);
    drawer.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    overlay.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
  }

  function handleRequestStarted(cart) {
    var nextCart = getCart(cart);

    if (!isActive() || pendingAddState.phase !== 'armed') {
      return;
    }

    pendingAddState.phase = 'pending';
    pendingAddState.startedAt = window.Date.now();
    pendingAddState.startItemCount = nextCart.item_count || 0;
    pendingAddState.startTotalPrice = nextCart.total_price || 0;

    applyPendingAddFeedback();
    updateCartCount(nextCart);
    openDrawer();
    setDrawerLoadingState(true);
  }

  function normalizeLiveCartTitles() {
    var elements = document.querySelectorAll('.escape-live-title');

    Array.prototype.forEach.call(elements, function(element) {
      element.textContent = decodeTextValue(element.textContent || '');
    });
  }

  function decodeTextValue(value) {
    return String(value || '').replace(/&amp;#39;/g, "'").replace(/&#39;/g, "'");
  }

  function isSubscriptionItem(item) {
    return !!(item && item.selling_plan_allocation);
  }

  function getUpsellPromptNodes() {
    return document.querySelectorAll('.upsell-prompt');
  }

  function setUpsellPromptVisibility(isVisible) {
    Array.prototype.forEach.call(getUpsellPromptNodes(), function(node) {
      node.classList.toggle('d-none', !isVisible);
    });
  }

  function getUpsellSlots() {
    return document.querySelectorAll('#upsell-list .upsell-grid li[data-handle]');
  }

  function hideUpsellSlot(slot) {
    if (!$ || !slot) {
      return;
    }

    $(slot).html('').addClass('d-none');
  }

  function showUpsellSlot(slot, html) {
    if (!$ || !slot) {
      return;
    }

    $(slot).html(html).removeClass('d-none').fadeIn(200);
  }

  function getConfiguredSlotHandle(index, slot) {
    if (HIGHLIGHTED_HANDLES[index]) {
      return HIGHLIGHTED_HANDLES[index];
    }

    return slot.getAttribute('data-handle') || '';
  }

  function getKitUpsellHandle(cart) {
    var firstItem = cart.items[0];

    if (!firstItem || isSubscriptionItem(firstItem)) {
      return '';
    }

    return KIT_UPSELL_MAP[firstItem.handle] || '';
  }

  function shouldHideUpsellHandle(slotHandle, cartHandles) {
    var conflictHandles = UPSELL_CONFLICTS[slotHandle] || [];
    var i;

    if (hasHandle(cartHandles, slotHandle)) {
      return true;
    }

    for (i = 0; i < conflictHandles.length; i += 1) {
      if (hasHandle(cartHandles, conflictHandles[i])) {
        return true;
      }
    }

    return false;
  }

  function formatPrice(priceInCents) {
    var amount = (priceInCents || 0) / 100;
    var rounded = Math.round(amount * 100) / 100;

    if (rounded % 1 === 0) {
      return rounded.toFixed(0);
    }

    return rounded.toFixed(2).replace(/0$/, '');
  }

  function formatMoneyDisplay(priceInCents) {
    var amount = Math.max(0, Math.round(priceInCents || 0)) / 100;

    return amount.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function getProductType(product) {
    return product.type || product.product_type || '';
  }

  function escapeAttribute(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(value) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = value || '';
    return (wrapper.textContent || wrapper.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function truncateText(value, maxLength) {
    var text = String(value || '').trim();

    if (!text || text.length <= maxLength) {
      return text;
    }

    return text.substring(0, maxLength).replace(/\s+\S*$/, '').trim() + '…';
  }

  function isFreeGiftHandle(handle) {
    return !!FREE_GIFT_HANDLES[handle];
  }

  function getGiftMeta(handle) {
    return GIFT_METADATA[handle] || null;
  }

  function getGiftBagItem(cart) {
    var items = (cart && cart.items) || [];
    var i;

    for (i = 0; i < items.length; i += 1) {
      if (String(items[i].variant_id) === GIFT_BAG_VARIANT_ID) {
        return items[i];
      }
    }

    return null;
  }


    function buildGiftItemSyncKey(itemId, quantity) {
    return String(itemId || '') + ':' + String(quantity);
  }

  function markGiftItemSyncPending(itemId, quantity) {
    var key = buildGiftItemSyncKey(itemId, quantity);

    giftItemSyncPending[key] = true;
    window.setTimeout(function() {
      delete giftItemSyncPending[key];
    }, 1500);
    return key;
  }

  function clearGiftItemSyncPending(key) {
    if (!key) {
      return;
    }

    delete giftItemSyncPending[key];
  }

  function syncGiftItemQuantity(item, quantity) {
    var targetQuantity = Number(quantity);
    var itemId;
    var pendingKey;

    if (!item || !(window.CartJS && typeof window.CartJS.updateItemById === 'function')) {
      return false;
    }

    itemId = Number(item.id);

    if (!itemId || Number(item.quantity || 0) === targetQuantity) {
      return false;
    }

    pendingKey = buildGiftItemSyncKey(itemId, targetQuantity);

    if (giftItemSyncPending[pendingKey]) {
      return true;
    }

    pendingKey = markGiftItemSyncPending(itemId, targetQuantity);

    window.CartJS.updateItemById(itemId, targetQuantity, {}, {
      success: function() {
        clearGiftItemSyncPending(pendingKey);
      },
      error: function() {
        clearGiftItemSyncPending(pendingKey);
      }
    });

    return true;
  }

  function getThresholdState(cart) {
    var totalPrice = cart.total_price || 0;
    var steps = getThresholdSteps();
    var nextStep = null;
    var lastStep = getLastThresholdStep();

    steps.forEach(function(step) {
      step.done = totalPrice >= step.at;

      if (!nextStep && !step.done) {
        nextStep = step;
      }
    });

    return {
      steps: steps,
      nextStep: nextStep,
      remaining: nextStep ? Math.max(0, nextStep.at - totalPrice) : 0,
      progressTarget: nextStep ? nextStep.at : (lastStep ? lastStep.at : 0),
      progress: nextStep ? Math.max(0, Math.min(100, (totalPrice / nextStep.at) * 100)) : 100
    };
  }

  function getThresholdCopyHtml(thresholdState) {
    if (!thresholdState.nextStep) {
      return 'Tu as débloqué la livraison offerte et les deux soins offerts !';
    }

    if (thresholdState.nextStep.key === 'shipping') {
      return 'Plus que <span class="live-cart-threshold-remaining">+' + formatMoneyDisplay(thresholdState.remaining) + '</span> pour profiter de la livraison offerte';
    }

    return 'Plus que <span class="live-cart-threshold-remaining">+' + formatMoneyDisplay(thresholdState.remaining) + '</span> pour recevoir <strong>' + escapeHtml(thresholdState.nextStep.rewardName) + '</strong> offert <span class="live-cart-threshold-value">(valeur ' + escapeHtml(thresholdState.nextStep.value) + ')</span>';
  }

  function updateThresholdCard(cart) {
    var thresholdCard = document.querySelector('.live-cart-threshold-card');
    var progressBar;
    var copyNode;
    var noteNode;
    var thresholdState;

    if (!thresholdCard) {
      return;
    }

    if (!cart.item_count) {
      thresholdCard.classList.add('d-none');
      return;
    }

    thresholdCard.classList.remove('d-none');
    thresholdState = getThresholdState(cart);
    progressBar = thresholdCard.querySelector('.live-cart-threshold-progress-bar');
    copyNode = thresholdCard.querySelector('.live-cart-threshold-copy');
    noteNode = thresholdCard.querySelector('.live-cart-threshold-note');

    Array.prototype.forEach.call(thresholdCard.querySelectorAll('[data-threshold-step]'), function(stepNode) {
      var stepKey = stepNode.getAttribute('data-threshold-step');
      var stepState = getThresholdStepByKey(stepKey);
      var iconNode = stepNode.querySelector('.live-cart-threshold-step-icon');
      var labelNode = stepNode.querySelector('.live-cart-threshold-step-label');
      var defaultIcon = stepKey === 'shipping' ? '🚚' : '🎁';
      var isCurrent = !!(thresholdState.nextStep && thresholdState.nextStep.key === stepKey);

      if (!stepState) {
        return;
      }

      stepNode.classList.toggle('is-complete', !!stepState.done);
      stepNode.classList.toggle('is-current', isCurrent);

      if (iconNode) {
        iconNode.textContent = stepState.done ? '✓' : defaultIcon;
      }

      if (labelNode) {
        labelNode.textContent = stepState.label;
      }
    });

    Array.prototype.forEach.call(thresholdCard.querySelectorAll('.live-cart-threshold-step-connector'), function(connector, index) {
      connector.classList.toggle('is-complete', !!(thresholdState.steps[index] && thresholdState.steps[index].done));
    });

    if (progressBar) {
      progressBar.style.width = thresholdState.progress + '%';
    }

    if (copyNode) {
      copyNode.innerHTML = getThresholdCopyHtml(thresholdState);
    }

    if (noteNode) {
      if ((cart.total_weight || 0) < 1) {
        noteNode.textContent = "Quand ta pre-commande sera disponible, nous t'enverrons un message et ta commande sera envoyee.";
        noteNode.classList.remove('d-none');
      } else {
        noteNode.textContent = '';
        noteNode.classList.add('d-none');
      }
    }
  }

  function findCartItemNodes() {
    return Array.prototype.filter.call(document.querySelectorAll('#LiveCart [data-handle]'), function(node) {
      return !!node.querySelector('.live-cart-item-title');
    });
  }

  function isGiftCartItem(item) {
    var title = item && (item.product_title || item.title || '');
    var handle = item && item.handle;
    var finalPrice = item && (item.final_price || item.discounted_price || 0);

    if (!item) {
      return false;
    }

    return isFreeGiftHandle(handle) || finalPrice < 1 || /cadeau special|cadeau spécial/i.test(title);
  }

  function sanitizeGiftTitle(title) {
    return String(title || '').replace(/^cadeau\s+sp[eé]cial\s*-\s*/i, '').trim();
  }

  function sanitizeGiftSubtitle(subtitle, comparePrice) {
    var nextSubtitle = String(subtitle || '').replace(/^offert:\s*/i, '').trim();

    if (comparePrice) {
      nextSubtitle = nextSubtitle.replace(/\s*,?\s*valeur de\s*[0-9]+(?:[.,][0-9]+)?\s*€/i, '').trim();
    }

    return nextSubtitle;
  }

  function findGiftSubtitleNode(itemNode) {
    var candidates = itemNode.querySelectorAll('.col-9 > .gotham');
    var i;

    for (i = 0; i < candidates.length; i += 1) {
      if (!candidates[i].classList.contains('plusoumoins') && !candidates[i].classList.contains('live-cart-item-preview-label')) {
        return candidates[i];
      }
    }

    return null;
  }

  function normalizePriceLabel(priceLabel) {
    var value = parseFloat(String(priceLabel || '').replace(/\s/g, '').replace(',', '.'));

    if (window.Number.isNaN(value)) {
      return '';
    }

    return value.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '€';
  }

  function getGiftComparePrice(item) {
    var handle = item && item.handle;
    var meta = getGiftMeta(handle);
    var details = item && (item.product_type || '');
    var detailMatch = details.match(/valeur de\s*([0-9]+(?:[.,][0-9]+)?)\s*€/i);

    if (!item) {
      return '';
    }

    if (meta && meta.comparePrice) {
      return meta.comparePrice;
    }

    if (item.original_price > 0) {
      return normalizePriceLabel(item.original_price / 100);
    }

    if (detailMatch && detailMatch[1]) {
      return normalizePriceLabel(detailMatch[1]);
    }

    return '';
  }

  function getCartItemPreviewHandle(item) {
    var meta;

    if (!item) {
      return '';
    }

    meta = getGiftMeta(item.handle);

    if (meta && meta.previewHandle) {
      return meta.previewHandle;
    }

    return item.handle || '';
  }

  function getCartItemDisplayData(item) {
    var isGiftItem = isGiftCartItem(item);
    var comparePrice = isGiftItem ? getGiftComparePrice(item) : '';
    var meta = getGiftMeta(item && item.handle);
    var title = decodeTextValue(item && (item.product_title || item.title || '') || '');
    var subtitle = decodeTextValue(item && item.product_type || '');

    if (isGiftItem) {
      return {
        isGift: true,
        title: meta && meta.title ? meta.title : sanitizeGiftTitle(title),
        subtitle: meta && meta.subtitle ? meta.subtitle : sanitizeGiftSubtitle(subtitle, comparePrice),
        comparePrice: comparePrice,
        previewHandle: getCartItemPreviewHandle(item)
      };
    }

    return {
      isGift: false,
      title: title,
      subtitle: subtitle,
      comparePrice: '',
      previewHandle: getCartItemPreviewHandle(item)
    };
  }

  function updateGiftPriceState(pricingNode, comparePrice, isGiftItem) {
    var compareNode;

    if (!pricingNode) {
      return;
    }

    pricingNode.classList.toggle('live-cart-item-pricing--gift', isGiftItem);
    compareNode = pricingNode.querySelector('.live-cart-gift-compare-price');

    if (!isGiftItem) {
      if (compareNode) {
        compareNode.parentNode.removeChild(compareNode);
      }
      return;
    }

    if (!compareNode) {
      compareNode = document.createElement('div');
      compareNode.className = 'live-cart-gift-compare-price';
      pricingNode.appendChild(compareNode);
    }

    if (comparePrice) {
      compareNode.textContent = comparePrice;
      compareNode.classList.remove('d-none');
    } else {
      compareNode.textContent = '';
      compareNode.classList.add('d-none');
    }
  }

  function applyGiftTitleMarkup(titleNode, titleText) {
    var badgeNode = document.createElement('span');
    var titleTextNode = document.createElement('span');

    titleNode.textContent = '';
    badgeNode.className = 'live-cart-gift-item-badge';
    badgeNode.textContent = 'OFFERT 🎁';
    titleTextNode.className = 'live-cart-item-title-text';
    titleTextNode.textContent = titleText;
    titleNode.appendChild(badgeNode);
    titleNode.appendChild(titleTextNode);
  }

    function updateGiftQuantityState(quantityNode, isGiftItem) {
    if (!quantityNode) {
      return;
    }

    quantityNode.classList.toggle('d-none', isGiftItem);
    quantityNode.setAttribute('aria-hidden', isGiftItem ? 'true' : 'false');

    Array.prototype.forEach.call(quantityNode.querySelectorAll('a'), function(link) {
      link.setAttribute('aria-disabled', isGiftItem ? 'true' : 'false');
      link.tabIndex = isGiftItem ? -1 : 0;
    });
  }


  function updateCartRowState(itemNode, item) {
    var titleNode = itemNode.querySelector('.live-cart-item-title');
    var subtitleNode = findGiftSubtitleNode(itemNode);
    var pricingNode = itemNode.querySelector('.live-cart-item-pricing');
    var displayData = getCartItemDisplayData(item);

    if (!item || !titleNode) {
      return;
    }

    itemNode.classList.add('live-cart-item');
    itemNode.classList.toggle('live-cart-item--gift', displayData.isGift);
    itemNode.setAttribute('data-cart-handle', item.handle || '');
    if (displayData.isGift) {
      applyGiftTitleMarkup(titleNode, displayData.title);

      if (subtitleNode) {
        subtitleNode.textContent = displayData.subtitle;
        subtitleNode.classList.add('live-cart-item-subtitle');
      }
    } else {
      titleNode.textContent = displayData.title;

      if (subtitleNode) {
        subtitleNode.textContent = displayData.subtitle;
        subtitleNode.classList.remove('live-cart-item-subtitle');
      }
    }

    updateGiftPriceState(pricingNode, displayData.comparePrice, displayData.isGift);
  }

  function updateGiftItemState(cart) {
    var itemNodes = findCartItemNodes();

    Array.prototype.forEach.call(itemNodes, function(itemNode, index) {
      updateCartRowState(itemNode, cart && cart.items ? cart.items[index] : null);
    });
  }

  function scheduleGiftItemStateUpdate(cart) {
    var sync = function() {
      updateGiftItemState(cart);
    };

    sync();

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(sync);
    }

    window.setTimeout(sync, 0);
    window.setTimeout(sync, 80);
  }

  function updateUpsellCopy(cart) {
    var copy = 'Complète ta routine';
    var thresholdState = getThresholdState(cart);

    if (thresholdState.nextStep) {
      if (thresholdState.nextStep.key === 'shipping') {
        copy = 'Ajoute un soin ciblé : avec +' + formatMoneyDisplay(thresholdState.remaining) + ' = livraison offerte';
      } else {
        copy = 'Complète ta routine : avec +' + formatMoneyDisplay(thresholdState.remaining) + ' = ' + thresholdState.nextStep.upsellCopy;
      }
    }

    Array.prototype.forEach.call(document.querySelectorAll('.live-cart-upsell-copy-v2'), function(node) {
      node.textContent = copy;
    });
  }

  function updateFooterSummary(cart) {
    var shippingStep = getShippingThresholdStep();
    var giftBagButton = document.querySelector('[data-cart-gift-toggle]');
    var giftBagStateNode = giftBagButton ? giftBagButton.querySelector('.live-cart-gift-state') : null;
    var totalNode = document.querySelector('.live-cart-total-value');
    var statusNode = document.querySelector('.live-cart-total-status');
    var checkoutButton = document.querySelector('.live-cart-checkout-button');
    var giftBagItem = getGiftBagItem(cart);

    if (giftBagButton) {
      giftBagButton.classList.toggle('is-added', !!giftBagItem);
      giftBagButton.setAttribute('aria-pressed', giftBagItem ? 'true' : 'false');
    }

    if (giftBagStateNode) {
      giftBagStateNode.textContent = '+0,50€ · ' + (giftBagItem ? '✓ Ajouté' : 'Ajouter');
    }

    if (totalNode) {
      totalNode.textContent = formatMoneyDisplay(cart.total_price || 0);
    }

    if (statusNode) {
      if ((cart.total_price || 0) >= shippingStep.at) {
        statusNode.textContent = '🚚 ' + shippingStep.label;
      } else {
        statusNode.textContent = 'Encore ' + formatMoneyDisplay(shippingStep.at - (cart.total_price || 0)) + ' pour la livraison offerte';
      }
    }

    if (checkoutButton) {
      checkoutButton.textContent = 'COMMANDER → ' + formatMoneyDisplay(cart.total_price || 0);
    }
  }

  function fetchUpsellProduct(handle) {
    if (!handle) {
      return hasPromiseSupport() ? window.Promise.resolve(null) : null;
    }

    if (productCache[handle]) {
      return hasPromiseSupport() ? window.Promise.resolve(productCache[handle]) : productCache[handle];
    }

    if (!productPromises[handle] && hasPromiseSupport() && $) {
      productPromises[handle] = new window.Promise(function(resolve, reject) {
        $.ajax({
          url: '/products/' + handle + '.js',
          dataType: 'json',
          cache: true
        }).done(function(product) {
          productCache[handle] = product;
          resolve(product);
        }).fail(reject);
      });
    }

    if (productPromises[handle]) {
      return productPromises[handle];
    }

    if ($) {
      $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        cache: true,
        async: false,
        success: function(data) {
          productCache[handle] = data;
        }
      });
    }

    return productCache[handle] || null;
  }

  function getAvailableVariant(product) {
    var variants = (product && product.variants) || [];
    var i;

    if (!variants.length) {
      return null;
    }

    for (i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false) {
        return variants[i];
      }
    }

    return variants[0];
  }

  function buildProductCardHtml(product, options) {
    var caption = options.caption;
    var buttonText = options.buttonText;
    var buttonData = options.buttonData || '';
    var previewHandle = options.previewHandle || product.handle;

    if (!product || !product.variants || !product.variants[0]) {
      return '';
    }

    return '' +
      '<div class="prod-upsell" data-cart-preview-source="upsell" data-cart-preview-handle="' + escapeAttribute(previewHandle) + '">' +
        '<button type="button" class="prod-upsell-media" data-cart-preview-trigger="true" data-cart-preview-handle="' + escapeAttribute(previewHandle) + '" aria-label="Aperçu rapide de ' + escapeAttribute(product.title) + '" onclick="if(window.NidecoCartRuntime){window.NidecoCartRuntime.openProductPreview(\'' + escapeAttribute(previewHandle) + '\', \'manual\');} return false;">' +
          '<img data-src="' + product.featured_image + '" class="img-fluid lazyload" alt="' + escapeAttribute(product.title) + '">' +
        '</button>' +
        '<div class="prod-upsell-body">' +
          '<button type="button" class="prod-upsell-link" data-cart-preview-trigger="true" data-cart-preview-handle="' + escapeAttribute(previewHandle) + '" onclick="if(window.NidecoCartRuntime){window.NidecoCartRuntime.openProductPreview(\'' + escapeAttribute(previewHandle) + '\', \'manual\');} return false;">' +
            '<h4 class="messina">' + escapeHtml(product.title) + '</h4>' +
          '</button>' +
          '<div class="prod-upsell-rating">' + STAR_RATING_SVG + '</div>' +
          '<div class="prod-upsell-caption">' + caption + '</div>' +
          '<div class="prod-upsell-actions">' +
            '<button class="upsell-cart btn--secondary" ' + buttonData + '>' + buttonText + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function buildRegularUpsellHtml(product) {
    return buildProductCardHtml(product, {
      caption: getUpsellBenefitCopy(product),
      buttonText: 'Ajouter · ' + formatPrice(product.price) + '€',
      buttonData: 'data-cart-add="' + product.variants[0].id + '"'
    });
  }

  function buildSwapUpsellHtml(product, cartItem) {
    var compareAt = product.compare_at_price || 0;
    var price = product.price || 0;
    var savings = compareAt > price ? ((compareAt - price) / compareAt) * 100 : 0;
    var currentTitle = cartItem.product_title || cartItem.title || '';

    return buildProductCardHtml(product, {
      caption: '<strong>Inclus ' + escapeHtml(currentTitle) + '</strong> · économise ' + Math.round(savings) + '%',
      buttonText: 'Echanger · ' + formatPrice(price) + '€',
      buttonData: 'data-cart-add="' + product.variants[0].id + '" data-cart-remove-id="' + cartItem.variant_id + '"'
    });
  }

  function renderUpsellGrid(cart) {
    var slots = getUpsellSlots();
    var cartHandles = getCartHandles(cart);
    var firstItem = cart.items[0];
    var renderQueue = [];
    var visibleCount = 0;

    if (!$ || !slots.length) {
      return;
    }

    Array.prototype.forEach.call(slots, function(slot, index) {
      var slotHandle = getConfiguredSlotHandle(index, slot);
      var productHandle = slotHandle;
      var isSwap = false;

      hideUpsellSlot(slot);

      if (!slotHandle || visibleCount >= MAX_UPSELLS) {
        return;
      }

      if (slotHandle === 'kit') {
        if (cart.total_price > getShippingThresholdStep().at) {
          return;
        }

        productHandle = getKitUpsellHandle(cart);

        if (!productHandle || shouldHideUpsellHandle(productHandle, cartHandles)) {
          return;
        }

        isSwap = true;
      } else if (shouldHideUpsellHandle(slotHandle, cartHandles)) {
        return;
      }

      visibleCount += 1;
      renderQueue.push({
        slot: slot,
        slotHandle: slotHandle,
        productHandle: productHandle,
        isSwap: isSwap
      });
    });

    setUpsellPromptVisibility(renderQueue.length > 0);

    if (!renderQueue.length) {
      return;
    }

    if (!hasPromiseSupport()) {
      renderQueue.forEach(function(entry) {
        var product = fetchUpsellProduct(entry.productHandle);
        var html = '';

        if (!product) {
          hideUpsellSlot(entry.slot);
          return;
        }

        html = entry.isSwap ? buildSwapUpsellHtml(product, firstItem) : buildRegularUpsellHtml(product);
        showUpsellSlot(entry.slot, html);
      });

      return;
    }

    window.Promise.all(renderQueue.map(function(entry) {
      return fetchUpsellProduct(entry.productHandle).then(function(product) {
        return {
          entry: entry,
          product: product
        };
      }).catch(function() {
        return {
          entry: entry,
          product: null
        };
      });
    })).then(function(results) {
      results.forEach(function(result) {
        var html = '';

        if (!result.product) {
          hideUpsellSlot(result.entry.slot);
          return;
        }

        html = result.entry.isSwap ? buildSwapUpsellHtml(result.product, firstItem) : buildRegularUpsellHtml(result.product);
        showUpsellSlot(result.entry.slot, html);
      });
    });
  }

  function getPreviewOverlay() {
    return document.getElementById('flex-modal-sidecart-preview');
  }

  function getPreviewModal() {
    return document.getElementById('sidecart-preview-modal');
  }

  function hideProductPreview() {
    var overlay = getPreviewOverlay();

    window.clearTimeout(previewState.hoverOpenTimer);
    window.clearTimeout(previewState.hoverCloseTimer);
    previewState.hoverOpenTimer = 0;
    previewState.hoverCloseTimer = 0;
    previewState.requestToken = '';
    previewState.activeHandle = '';
    previewState.activeProduct = null;
    previewState.isOpen = false;
    previewState.lastTrigger = '';
    previewState.isInsideModal = false;
    previewState.quickAddVariantId = '';

    if (!overlay) {
      return;
    }

    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.display = 'none';
  }

  function getResizedImageUrl(url, size) {
    return String(url || '').replace(/(_\d+x\d*)?\.([a-z]{3,4})(\?|$)/i, '_' + size + '.$2$3');
  }

  function getUpsellBenefitCopy(product) {
    var benefit = UPSELL_BENEFIT_MAP[product.handle];

    if (benefit) {
      return escapeHtml(benefit);
    }

    var type = getProductType(product);

    return type ? escapeHtml(type) : '';
  }

  function getPreviewThresholdNudge(product) {
    var variant = getAvailableVariant(product);
    var currentCart = getCart();
    var productPrice = variant ? (variant.price || product.price || 0) : (product.price || 0);
    var projectedTotal = (currentCart.total_price || 0) + productPrice;
    var thresholdState = getThresholdState(currentCart);

    if (!thresholdState.nextStep) {
      return '';
    }

    if (projectedTotal >= thresholdState.nextStep.at) {
      if (thresholdState.nextStep.key === 'shipping') {
        return '🚚 Avec ce produit → livraison offerte !';
      }

      return '🎁 Avec ce produit → ' + escapeHtml(thresholdState.nextStep.rewardName) + ' offert !';
    }

    return '';
  }

  function getPreviewDescription(product) {
    var description = stripHtml(product && product.description);

    if (!description) {
      description = stripHtml(product && product.body_html);
    }

    if (!description) {
      description = getProductType(product);
    }

    return truncateText(description, PREVIEW_CONFIG.descriptionLength);
  }

  function populatePreviewModal(product, handle, trigger) {
    var modal = getPreviewModal();
    var actionsNode;
    var imageNode;
    var titleNode;
    var typeNode;
    var priceNode;
    var compareNode;
    var descriptionNode;
    var addButton;
    var linkNode;
    var ratingNode;
    var thumbnailsNode;
    var nudgeNode;
    var variant;
    var comparePrice;

    if (!modal || !product) {
      return;
    }

    imageNode = modal.querySelector('.live-cart-preview-image');
    titleNode = modal.querySelector('.live-cart-preview-title');
    typeNode = modal.querySelector('.live-cart-preview-type');
    priceNode = modal.querySelector('.live-cart-preview-price');
    compareNode = modal.querySelector('.live-cart-preview-compare');
    descriptionNode = modal.querySelector('.live-cart-preview-description');
    actionsNode = modal.querySelector('.live-cart-preview-actions');
    addButton = modal.querySelector('[data-cart-preview-add]');
    linkNode = modal.querySelector('.live-cart-preview-link');
    ratingNode = modal.querySelector('.live-cart-preview-rating');
    thumbnailsNode = modal.querySelector('.live-cart-preview-thumbnails');
    nudgeNode = modal.querySelector('.live-cart-preview-nudge');
    variant = getAvailableVariant(product);
    comparePrice = product.compare_at_price || 0;

    previewState.activeProduct = product;
    previewState.activeHandle = handle;
    previewState.quickAddVariantId = variant ? String(variant.id) : '';
    previewState.lastTrigger = trigger || 'manual';

    if (imageNode) {
      imageNode.src = product.featured_image || '';
      imageNode.alt = product.title || '';
    }

    /* A3 — thumbnail gallery */
    if (thumbnailsNode) {
      if (product.images && product.images.length > 1) {
        var thumbHtml = '';
        var maxThumbs = Math.min(product.images.length, 5);
        var ti;

        for (ti = 0; ti < maxThumbs; ti += 1) {
          thumbHtml += '<button type="button" class="live-cart-preview-thumb' + (ti === 0 ? ' is-active' : '') + '" data-preview-thumb-index="' + ti + '">' +
            '<img src="' + getResizedImageUrl(product.images[ti], '200x200') + '" alt="">' +
            '</button>';
        }

        thumbnailsNode.innerHTML = thumbHtml;
        thumbnailsNode.classList.remove('d-none');

        Array.prototype.forEach.call(thumbnailsNode.querySelectorAll('.live-cart-preview-thumb'), function(thumb) {
          thumb.addEventListener('click', function() {
            var idx = Number(thumb.getAttribute('data-preview-thumb-index'));

            if (imageNode && product.images[idx]) {
              imageNode.src = product.images[idx];
              Array.prototype.forEach.call(thumbnailsNode.querySelectorAll('.live-cart-preview-thumb'), function(t) {
                t.classList.remove('is-active');
              });
              thumb.classList.add('is-active');
            }
          });
        });
      } else {
        thumbnailsNode.innerHTML = '';
        thumbnailsNode.classList.add('d-none');
      }
    }

    if (titleNode) {
      titleNode.textContent = product.title || '';
    }

    /* A1 — star rating social proof */
    if (ratingNode) {
      ratingNode.innerHTML = STAR_RATING_SVG;
    }

    if (typeNode) {
      typeNode.textContent = getProductType(product);
      typeNode.classList.toggle('d-none', !typeNode.textContent);
    }

    if (priceNode) {
      priceNode.textContent = formatMoneyDisplay(product.price || 0);
    }

    if (compareNode) {
      if (comparePrice > (product.price || 0)) {
        compareNode.textContent = formatMoneyDisplay(comparePrice);
        compareNode.classList.remove('d-none');
      } else {
        compareNode.textContent = '';
        compareNode.classList.add('d-none');
      }
    }

    if (descriptionNode) {
      descriptionNode.textContent = getPreviewDescription(product);
      descriptionNode.classList.toggle('d-none', !descriptionNode.textContent);
    }

    /* A5 — threshold nudge */
    if (nudgeNode) {
      var nudgeText = getPreviewThresholdNudge(product);

      if (nudgeText) {
        nudgeNode.innerHTML = nudgeText;
        nudgeNode.classList.remove('d-none');
      } else {
        nudgeNode.innerHTML = '';
        nudgeNode.classList.add('d-none');
      }
    }

    if (addButton) {
      addButton.disabled = !variant || variant.available === false;
      addButton.classList.remove('live-cart-preview-add--success');
      addButton.textContent = variant && variant.available !== false ? PREVIEW_CONFIG.quickAddLabel + ' · ' + formatPrice(variant.price || product.price || 0) + '€' : 'Indisponible';
      addButton.setAttribute('data-cart-preview-variant-id', previewState.quickAddVariantId);
    }

    if (!linkNode && actionsNode) {
      linkNode = document.createElement('a');
      linkNode.className = 'btn--secondary live-cart-preview-link';
      linkNode.textContent = 'Voir le produit';
      linkNode.target = '_blank';
      linkNode.rel = 'noopener noreferrer';
      actionsNode.appendChild(linkNode);
    }

    if (linkNode) {
      linkNode.href = '/products/' + (product.handle || handle);
      linkNode.target = '_blank';
      linkNode.rel = 'noopener noreferrer';
    }
  }

  function showProductPreview(product, handle, trigger) {
    var overlay = getPreviewOverlay();

    if (!overlay || !product) {
      return;
    }

    previewState.isInsideModal = false;
    populatePreviewModal(product, handle, trigger);
    overlay.style.display = 'flex';
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    previewState.isOpen = true;
  }

  function openProductPreview(handle, trigger) {
    var requestToken = String(window.Date.now()) + ':' + handle;
    var productRequest;

    if (!handle || !isActive()) {
      return;
    }

    previewState.requestToken = requestToken;
    productRequest = fetchUpsellProduct(handle);

    if (hasPromiseSupport() && productRequest && typeof productRequest.then === 'function') {
      productRequest.then(function(product) {
        if (previewState.requestToken !== requestToken || !product) {
          return;
        }

        showProductPreview(product, handle, trigger);
      }).catch(function() {
        return;
      });

      return;
    }

    if (productRequest) {
      showProductPreview(productRequest, handle, trigger);
    }
  }

  function handlePreviewQuickAdd() {
    var variantId = Number(previewState.quickAddVariantId);
    var modal = getPreviewModal();
    var addButton = modal ? modal.querySelector('[data-cart-preview-add]') : null;

    if (!variantId || !(window.CartJS && typeof window.CartJS.addItem === 'function')) {
      return;
    }

    /* A7 — show success feedback before closing */
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Ajouté ✓';
      addButton.classList.add('live-cart-preview-add--success');
    }

    window.CartJS.addItem(variantId, 1, {});

    window.setTimeout(function() {
      hideProductPreview();

      if (addButton) {
        addButton.classList.remove('live-cart-preview-add--success');
      }
    }, 700);
  }

  function bindProductPreview() {
    var modal = getPreviewModal();
    var overlay = getPreviewOverlay();

    document.addEventListener('click', function(event) {
      var runtimeTrigger = findClosestWithAttribute(event.target, 'data-cart-runtime-preview');
      var runtimeReset = findClosestWithAttribute(event.target, 'data-cart-runtime-reset');
      var previewTrigger = findClosestWithAttribute(event.target, 'data-cart-preview-trigger');
      var previewClose = findClosestWithAttribute(event.target, 'data-cart-preview-close');
      var previewAdd = findClosestWithAttribute(event.target, 'data-cart-preview-add');

      if (runtimeTrigger) {
        setPreviewMode(runtimeTrigger.getAttribute('data-cart-runtime-preview') || PREVIEW_VALUE);
        return;
      }

      if (runtimeReset) {
        setPreviewMode('off');
        return;
      }

      if (previewTrigger) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        openProductPreview(previewTrigger.getAttribute('data-cart-preview-handle') || '', 'manual');
        return;
      }

      if (previewClose) {
        event.preventDefault();
        hideProductPreview();
        return;
      }

      if (previewAdd) {
        event.preventDefault();
        handlePreviewQuickAdd();
        return;
      }

      if (overlay && event.target === overlay) {
        hideProductPreview();
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && previewState.isOpen) {
        hideProductPreview();
      }
    });

    if (modal) {
      modal.addEventListener('mouseenter', function() {
        previewState.isInsideModal = true;
      });

      modal.addEventListener('mouseleave', function() {
        previewState.isInsideModal = false;
      });
    }
  }

  function bindGiftBagToggle() {
    document.addEventListener('click', function(event) {
      var trigger = findClosestWithAttribute(event.target, 'data-cart-gift-toggle');
      var currentCart;

      if (!trigger || !isActive()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (giftBagPending || !(window.CartJS && typeof window.CartJS.addItem === 'function')) {
        return;
      }

      currentCart = getCart();
      giftBagPending = true;
      window.setTimeout(function() {
        giftBagPending = false;
      }, 1500);

      if (getGiftBagItem(currentCart) && typeof window.CartJS.removeItemById === 'function') {
        window.CartJS.removeItemById(Number(GIFT_BAG_VARIANT_ID));
        return;
      }

      window.CartJS.addItem(Number(GIFT_BAG_VARIANT_ID), 1, {});
    }, true);
  }

  function syncThresholdUpsells(cart) {
    var firstItem = cart.items[0];
    var giftOneStep = getThresholdStepByKey('gift-one') || DEFAULT_THRESHOLDS[1];
    var giftTwoStep = getThresholdStepByKey('gift-two') || DEFAULT_THRESHOLDS[2];
    var hasFreeGift = false;
    var hasSecondFreeGift = false;
    var eligibleForGiftOne = cart.total_price >= giftOneStep.at;
    var eligibleForGiftTwo = cart.total_price >= giftTwoStep.at;
    var giftOneItem = null;
    var giftTwoItem = null;
    var hasVdiKit = false;
    var quantitySyncQueued = false;

    if (!(window.CartJS && cart && cart.items)) {
      return;
    }

    cart.items.forEach(function(item) {
      if (item.handle === 'offre-speciale-two-cart') {
        giftOneItem = item;
      }

      if (item.handle === 'offre-speciale-cart') {
        giftTwoItem = item;
      }

      if (item.handle === 'coffret-lancement-vdi') {
        hasVdiKit = true;
      }

      if (FREE_GIFT_HANDLES[item.handle] && item.handle !== 'offre-speciale-two-cart' && item.handle !== 'offre-speciale-cart') {
        if (syncGiftItemQuantity(item, 1)) {
          quantitySyncQueued = true;
        }
      }
    });

    if (hasVdiKit) {
      if (giftOneItem && syncGiftItemQuantity(giftOneItem, 0)) {
        return;
      }

      if (giftTwoItem && syncGiftItemQuantity(giftTwoItem, 0)) {
        return;
      }

      if (quantitySyncQueued) {
        return;
      }

      return;
    }

    if (giftOneItem) {
      if (!eligibleForGiftOne && syncGiftItemQuantity(giftOneItem, 0)) {
        return;
      }

      if (eligibleForGiftOne && syncGiftItemQuantity(giftOneItem, 1)) {
        return;
      }
    }

    if (giftTwoItem) {
      if (!eligibleForGiftTwo && syncGiftItemQuantity(giftTwoItem, 0)) {
        return;
      }

      if (eligibleForGiftTwo && syncGiftItemQuantity(giftTwoItem, 1)) {
        return;
      }
    }

    if (quantitySyncQueued) {
      return;
    }

    if (eligibleForGiftOne && !giftOneItem && typeof window.addfreeproduct === 'function') {
      window.addfreeproduct();
      return;
    }

    if (eligibleForGiftTwo && !giftTwoItem && typeof window.addsecondfreeproduct === 'function') {
      window.addsecondfreeproduct();
      return;
    }

    if (!eligibleForGiftTwo && giftTwoItem && syncGiftItemQuantity(giftTwoItem, 0)) {
      return;
    }

    if (firstItem && firstItem.handle === 'offre-speciale-two-cart' && !eligibleForGiftOne && syncGiftItemQuantity(firstItem, 0)) {
      return;
    }
  }
  
  function maybeOpenSingleItemUpsell(cart) {
    var item = cart.items[0];

    if (!$ || cart.item_count !== 1 || !item || isSubscriptionItem(item)) {
      return;
    }

    if (item.handle === 'fesse-time') {
      $('#new-modal-upsell').addClass('d-block');
      $('#flex-modal-upsell').addClass('d-flex');
      $('#LiveCart').addClass('blur');
    }

    if (item.handle === 'oh-my-periods') {
      $('#new-modal-upsell-omp').addClass('d-block');
      $('#flex-modal-upsell-omp').addClass('d-flex');
      $('#LiveCart').addClass('blur');
    }

    if (item.handle === 'all-i-need-hydratant-anti-pollution') {
      $('#new-modal-upsell-ain').addClass('d-block');
      $('#flex-modal-upsell-ain').addClass('d-flex');
      $('#LiveCart').addClass('blur');
    }
  }

  function applyCartState(cart) {
    var steps = getThresholdSteps();

    setProgressBar('progress-frise', cart.total_price, steps[0] && steps[0].at);
    setProgressBar('progress2-frise', cart.total_price, steps[1] && steps[1].at);
    setProgressBar('progress3-frise', cart.total_price, steps[2] && steps[2].at);
    normalizeLiveCartTitles();
    updateThresholdCard(cart);
    scheduleGiftItemStateUpdate(cart);
    updateUpsellCopy(cart);
    updateFooterSummary(cart);
    renderUpsellGrid(cart);
  }

  function openDrawer() {
    if (!$) {
      return;
    }

    $('#LiveCart').fadeIn(100).removeClass('d-none');
    $('body').addClass('openmodal');
    $('main').addClass('blur');
    $('header').addClass('blur');
  }

  function closeDrawer() {
    if (!$) {
      return;
    }

    setDrawerLoadingState(false);
    hideProductPreview();
    $('#LiveCart').fadeOut(400).addClass('d-none').removeClass('blur');
    $('body').removeClass('openmodal');
    $('main').removeClass('blur');
    $('header').removeClass('blur');
    $('.flex-modal-upsell').removeClass('d-flex');
    $('#new-modal-upsell, #new-modal-upsell-omp, #new-modal-upsell-ain').removeClass('d-block');
  }

  function handleReady(cart) {
    var nextCart = getCart(cart);

    if (!isActive()) {
      return;
    }

    giftBagPending = false;
    setDrawerLoadingState(false);
    updateCartCount(nextCart);
    applyCartState(nextCart);
  }

  function handleRequestComplete(cart) {
    var nextCart = getCart(cart);
    var didAddSucceed;

    if (!isActive()) {
      return;
    }

    giftBagPending = false;
    updateCartCount(nextCart);
    applyCartState(nextCart);
    openDrawer();
    didAddSucceed = didPendingAddChangeCart(nextCart);
    updateAddToCartFeedback(didAddSucceed);
    syncThresholdUpsells(nextCart);
    maybeOpenSingleItemUpsell(nextCart);
  }

  function getPendingButtonsFromForm(form, submitter) {
    var buttons = [];

    if (!form) {
      return buttons;
    }

    if (submitter) {
      buttons.push(submitter);
    }

    Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]'), function(button) {
      if (buttons.indexOf(button) === -1) {
        buttons.push(button);
      }
    });

    return buttons;
  }

  function bindAddToCartIntent() {
    document.addEventListener('submit', function(event) {
      var form = findClosestBySelector(event.target, '[data-cart-submit]');
      var submitter = event.submitter || findClosestBySelector(document.activeElement, 'button[type="submit"], input[type="submit"]');

      if (!form || !isActive()) {
        return;
      }

      rememberPendingAdd(getPendingButtonsFromForm(form, submitter));
    }, true);

    document.addEventListener('click', function(event) {
      var addTrigger = findClosestWithAttribute(event.target, 'data-cart-add');

      if (!addTrigger || !isActive()) {
        return;
      }

      rememberPendingAdd([addTrigger]);
    }, true);
  }

  function bindCartRequestLifecycle() {
    if (!$) {
      return;
    }

    $(document).on('cart.requestStarted', function(event, cart) {
      handleRequestStarted(cart);
    });
  }

  syncPreviewModeFromQuery();
  syncRootMode();
  bindGiftBagToggle();
  bindProductPreview();
  bindAddToCartIntent();
  bindCartRequestLifecycle();

  window.NidecoCartRuntime = {
    isActive: isActive,
    setMode: setPreviewMode,
    handleRequestStarted: handleRequestStarted,
    handleReady: handleReady,
    handleRequestComplete: handleRequestComplete,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    renderUpsellGrid: renderUpsellGrid,
    syncThresholdUpsells: syncThresholdUpsells,
    maybeOpenSingleItemUpsell: maybeOpenSingleItemUpsell,
    openProductPreview: openProductPreview
  };
})(window, document, window.jQuery);
